export const lrfdComboData = {
  "prettyEquations": [
    { "EQ": "1.4D", "common": true, "lambda": 0.6 },
    { "EQ": "1.2D + 1.6L + 0.5Lr", "common": true, "lambda": 0.8 },
    { "EQ": "1.2D + 1.6L + 0.5S", "common": true, "lambda": 0.8 },
    { "EQ": "1.2D + 1.6L + 0.5R", "common": false, "lambda": 0.8 },
    { "EQ": "1.2D + 1.6Lr + 1.0L", "common": true, "lambda": 0.8 },
    { "EQ": "1.2D + 1.6S + 1.0L", "common": false, "lambda": 0.8 },
    { "EQ": "1.2D + 1.6R + 1.0L", "common": false, "lambda": 0.8 },
    { "EQ": "1.2D + 1.6Lr + 0.8W", "common": true, "lambda": 0.8 },
    { "EQ": "1.2D + 1.6S + 0.8W", "common": true, "lambda": 0.8 },
    { "EQ": "1.2D + 1.6R + 0.8W", "common": false, "lambda": 0.8 },
    { "EQ": "1.2D + 1.6W + 1.0L + 0.5Lr", "common": true, "lambda": 1.0 },
    { "EQ": "1.2D + 1.6W + 1.0L + 0.5S", "common": true, "lambda": 1.0 },
    { "EQ": "1.2D + 1.6W + 1.0L + 0.5R", "common": false, "lambda": 1.0 },
    { "EQ": "1.2D + 1.0E + 1.0L + 0.2S", "common": true, "lambda": 1.0 },
    { "EQ": "1.2D - 1.0E + 1.0L + 0.2S", "common": false, "lambda": 1.0 },
    { "EQ": "0.9D + 1.6W", "common": true, "lambda": 1.0 },
    { "EQ": "0.9D + 1.0E", "common": true, "lambda": 1.0 },
    { "EQ": "0.9D - 1.6W", "common": false, "lambda": 1.0 },
    { "EQ": "0.9D - 1.0E", "common": false, "lambda": 1.0 }
  ],

  "equations": [
    { "Name": "EQ1", "D": "1.4", "L": "0", "Lr": "0", "S": "0", "R": "0", "W": "0", "E": "0", "H": "0" },
    { "Name": "EQ2", "D": "1.2", "L": "1.6", "Lr": "0.5", "S": "0", "R": "0", "W": "0", "E": "0", "H": "0" },
    { "Name": "EQ3", "D": "1.2", "L": "1.6", "Lr": "0", "S": "0.5", "R": "0", "W": "0", "E": "0", "H": "0" },
    { "Name": "EQ4", "D": "1.2", "L": "1.6", "Lr": "0", "S": "0", "R": "0.5", "W": "0", "E": "0", "H": "0" },
    { "Name": "EQ5", "D": "1.2", "L": "1.0", "Lr": "1.6", "S": "0", "R": "0", "W": "0", "E": "0", "H": "0" },
    { "Name": "EQ6", "D": "1.2", "L": "1.0", "Lr": "0", "S": "1.6", "R": "0", "W": "0", "E": "0", "H": "0" },
    { "Name": "EQ7", "D": "1.2", "L": "1.0", "Lr": "0", "S": "0", "R": "1.6", "W": "0", "E": "0", "H": "0" },
    { "Name": "EQ8", "D": "1.2", "L": "0", "Lr": "1.6", "S": "0", "R": "0", "W": "0.8", "E": "0", "H": "0" },
    { "Name": "EQ9", "D": "1.2", "L": "0", "Lr": "0", "S": "1.6", "R": "0", "W": "0.8", "E": "0", "H": "0" },
    { "Name": "EQ10", "D": "1.2", "L": "0", "Lr": "0", "S": "0", "R": "1.6", "W": "0.8", "E": "0", "H": "0" },
    { "Name": "EQ11", "D": "1.2", "L": "1.0", "Lr": "0.5", "S": "0", "R": "0", "W": "1.6", "E": "0", "H": "0" },
    { "Name": "EQ12", "D": "1.2", "L": "1.0", "Lr": "0", "S": "0.5", "R": "0", "W": "1.6", "E": "0", "H": "0" },
    { "Name": "EQ13", "D": "1.2", "L": "1.0", "Lr": "0", "S": "0", "R": "0.5", "W": "1.6", "E": "0", "H": "0" },
    { "Name": "EQ14", "D": "1.2", "L": "1.0", "Lr": "0", "S": "0.2", "R": "0", "W": "0", "E": "1", "H": "0" },
    { "Name": "EQ15", "D": "1.2", "L": "1.0", "Lr": "0", "S": "0.2", "R": "0", "W": "0", "E": "-1", "H": "0" },
    { "Name": "EQ16", "D": "0.9", "L": "0", "Lr": "0", "S": "0", "R": "0", "W": "1.6", "E": "0", "H": "0" },
    { "Name": "EQ17", "D": "0.9", "L": "0", "Lr": "0", "S": "0", "R": "0", "W": "-1.6", "E": "0", "H": "0" },
    { "Name": "EQ18", "D": "0.9", "L": "0", "Lr": "0", "S": "0", "R": "0", "W": "0", "E": "1", "H": "0" },
    { "Name": "EQ19", "D": "0.9", "L": "0", "Lr": "0", "S": "0", "R": "0", "W": "0", "E": "-1", "H": "0" }
  ]
}

export const asdComboData = {
  "prettyEquations": [
    { "EQ": "D", "common": true, "Cd": 0.9 },
    { "EQ": "D + L", "common": true, "Cd": 1.0 },
    { "EQ": "D + Lr", "common": true, "Cd": 1.25 },
    { "EQ": "D + S", "common": true, "Cd": 1.15 },
    { "EQ": "D + R", "common": false, "Cd": 1.15 },
    { "EQ": "D + 0.75L + 0.75Lr", "common": true, "Cd": 1.25 },
    { "EQ": "D + 0.75L + 0.75S", "common": true, "Cd": 1.15 },
    { "EQ": "D + 0.75L + 0.75R", "common": false, "Cd": 1.15 },
    { "EQ": "D + W", "common": true, "Cd": 1.6 },
    { "EQ": "D + 0.7E", "common": true, "Cd": 1.6 },
    { "EQ": "D - W ", "common": false, "Cd": 1.6 },
    { "EQ": "D - 0.7E", "common": false, "Cd": 1.6 },
    { "EQ": "D + 0.75W + 0.75L + 0.75Lr", "common": true, "Cd": 1.25 },
    { "EQ": "D + 0.75W + 0.75L + 0.75S", "common": true, "Cd": 1.15 },
    { "EQ": "D + 0.75W + 0.75L + 0.75R", "common": false, "Cd": 1.15 },
    { "EQ": "D + 0.525E + 0.75L + 0.75Lr", "common": true, "Cd": 1.6 },
    { "EQ": "D + 0.525E + 0.75L + 0.75S", "common": true, "Cd": 1.6 },
    { "EQ": "D + 0.525E + 0.75L + 0.75R", "common": false, "Cd": 1.6 },
    { "EQ": "0.6D + W", "common": true, "Cd": 1.6 },
    { "EQ": "0.6D + 0.7E", "common": true, "Cd": 1.6 },
    { "EQ": "0.6D - W", "common": false, "Cd": 1.6 },
    { "EQ": "0.6D - 0.7E", "common": false, "Cd": 1.6 }
  ],

  "equations": [
    { "Name": "EQ1", "D": "1", "L": "0", "Lr": "0", "S": "0", "R": "0", "W": "0", "E": "0", "H": "0" },
    { "Name": "EQ2", "D": "1", "L": "1", "Lr": "0", "S": "0", "R": "0", "W": "0", "E": "0", "H": "0" },
    { "Name": "EQ3", "D": "1", "L": "0", "Lr": "1", "S": "0", "R": "0", "W": "0", "E": "0", "H": "0" },
    { "Name": "EQ4", "D": "1", "L": "0", "Lr": "0", "S": "1", "R": "0", "W": "0", "E": "0", "H": "0" },
    { "Name": "EQ5", "D": "1", "L": "0", "Lr": "0", "S": "0", "R": "1", "W": "0", "E": "0", "H": "0" },
    { "Name": "EQ6", "D": "1", "L": "0.75", "Lr": "0.75", "S": "0", "R": "0", "W": "0", "E": "0", "H": "0" },
    { "Name": "EQ7", "D": "1", "L": "0.75", "Lr": "0", "S": "0.75", "R": "0", "W": "0", "E": "0", "H": "0" },
    { "Name": "EQ8", "D": "1", "L": "0.75", "Lr": "0", "S": "0", "R": "0.75", "W": "0", "E": "0", "H": "0" },
    { "Name": "EQ9", "D": "1", "L": "0", "Lr": "0", "S": "0", "R": "0", "W": "1", "E": "0", "H": "0" },
    { "Name": "EQ10", "D": "1", "L": "0", "Lr": "0", "S": "0", "R": "0", "W": "0", "E": "0.7", "H": "0" },
    { "Name": "EQ11", "D": "1", "L": "0", "Lr": "0", "S": "0", "R": "0", "W": "-1", "E": "0", "H": "0" },
    { "Name": "EQ12", "D": "1", "L": "0", "Lr": "0", "S": "0", "R": "0", "W": "0", "E": "-0.7", "H": "0" },
    { "Name": "EQ13", "D": "1", "L": "0.75", "Lr": "0.75", "S": "0", "R": "0", "W": "0.75", "E": "0", "H": "0" },
    { "Name": "EQ14", "D": "1", "L": "0.75", "Lr": "0", "S": "0.75", "R": "0", "W": "0.75", "E": "0.7", "H": "0" },
    { "Name": "EQ15", "D": "1", "L": "0.75", "Lr": "0", "S": "0", "R": "0.75", "W": "0.75", "E": "0", "H": "0" },
    { "Name": "EQ16", "D": "1", "L": "0.75", "Lr": "0.75", "S": "0", "R": "0", "W": "0", "E": "0.525", "H": "0" },
    { "Name": "EQ17", "D": "1", "L": "0.75", "Lr": "0", "S": "0.75", "R": "0", "W": "0", "E": "0.525", "H": "0" },
    { "Name": "EQ18", "D": "1", "L": "0.75", "Lr": "0", "S": "0", "R": "0.75", "W": "0", "E": "0.525", "H": "0" },
    { "Name": "EQ19", "D": "0.6", "L": "0", "Lr": "0", "S": "0", "R": "0", "W": "1", "E": "0", "H": "0" },
    { "Name": "EQ20", "D": "0.6", "L": "0", "Lr": "0", "S": "0", "R": "0", "W": "0", "E": "0.7", "H": "0" },
    { "Name": "EQ21", "D": "0.6", "L": "0", "Lr": "0", "S": "0", "R": "0", "W": "-1", "E": "0", "H": "0" },
    { "Name": "EQ22", "D": "0.6", "L": "0", "Lr": "0", "S": "0", "R": "0", "W": "0", "E": "-0.7", "H": "0" }
  ]
}

export const noComboData = {
  "prettyEquations": [
    { "EQ": "D" },
    { "EQ": "L" },
    { "EQ": "Lr" },
    { "EQ": "S" },
    { "EQ": "R" },
    { "EQ": "W" },
    { "EQ": "E" },
    { "EQ": "H" }
  ],

  "equations": [
    { "Name": "EQ1", "D": "1.0", "L": "0.0", "Lr": "0.0", "S": "0.0", "R": "0.0", "W": "0.0", "E": "0.0", "H": "0.0" },
    { "Name": "EQ2", "D": "0.0", "L": "1.0", "Lr": "0.0", "S": "0.0", "R": "0.0", "W": "0.0", "E": "0.0", "H": "0.0" },
    { "Name": "EQ3", "D": "0.0", "L": "0.0", "Lr": "1.0", "S": "0.0", "R": "0.0", "W": "0.0", "E": "0.0", "H": "0.0" },
    { "Name": "EQ4", "D": "0.0", "L": "0.0", "Lr": "0.0", "S": "1.0", "R": "0.0", "W": "0.0", "E": "0.0", "H": "0.0" },
    { "Name": "EQ5", "D": "0.0", "L": "0.0", "Lr": "0.0", "S": "0.0", "R": "1.0", "W": "0.0", "E": "0.0", "H": "0.0" },
    { "Name": "EQ6", "D": "0.0", "L": "0.0", "Lr": "0.0", "S": "0.0", "R": "0.0", "W": "1.0", "E": "0.0", "H": "0.0" },
    { "Name": "EQ7", "D": "0.0", "L": "0.0", "Lr": "0.0", "S": "0.0", "R": "0.0", "W": "0.0", "E": "1.0", "H": "0.0" },
    { "Name": "EQ8", "D": "0.0", "L": "0.0", "Lr": "0.0", "S": "0.0", "R": "0.0", "W": "0.0", "E": "0.0", "H": "1.0" }
  ]
}

export const serviceComboData = {
  "prettyEquations": [
    { "EQ": "L (service)", "common": false },
    { "EQ": "L+Lr (service)", "common": true },
    { "EQ": "L+S (service)", "common": true },
    { "EQ": "D+L (service)", "common": false },
    { "EQ": "S (service)", "common": false },
    { "EQ": "W (service)", "common": false },
    { "EQ": "TL = D+L+S+R+W+H (service)", "common": true }
  ],

  "equations": [
    { "Name": "EQ1", "D": "0.0", "L": "1.0", "Lr": "0.0", "S": "0.0", "R": "0.0", "W": "0.0", "E": "0.0", "H": "0.0" },
    { "Name": "EQ2", "D": "0.0", "L": "1.0", "Lr": "1.0", "S": "0.0", "R": "0.0", "W": "0.0", "E": "0.0", "H": "0.0" },
    { "Name": "EQ3", "D": "0.0", "L": "1.0", "Lr": "0.0", "S": "1.0", "R": "0.0", "W": "0.0", "E": "0.0", "H": "0.0" },
    { "Name": "EQ4", "D": "1.0", "L": "1.0", "Lr": "0.0", "S": "0.0", "R": "0.0", "W": "0.0", "E": "0.0", "H": "0.0" },
    { "Name": "EQ5", "D": "0.0", "L": "0.0", "Lr": "0.0", "S": "1.0", "R": "0.0", "W": "0.0", "E": "0.0", "H": "0.0" },
    { "Name": "EQ6", "D": "0.0", "L": "0.0", "Lr": "0.0", "S": "0.0", "R": "0.0", "W": "1.0", "E": "0.0", "H": "0.0" },
    { "Name": "EQ7", "D": "1.0", "L": "1.0", "Lr": "0.0", "S": "1.0", "R": "1.0", "W": "1.0", "E": "0.0", "H": "1.0" }
  ]
}
